export const heading = "Ready To Bill Report";
export const completeListLink = "quadreport6";
